import { useEffect, useState } from "react";
import styles from "./list.module.css";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { Button, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { authData } from "../../../components/GetAuth";

export default function AssignPopup({ setLoading, modalClose, bookingIds, onSubmit }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [driverList, setDriverList] = useState([]);

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/p-driver-dd-list", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setDriverList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const onSubmitLocal = (data) => {
    modalClose(false);
    setLoading(true);

    data = { ...data, bookingIds: bookingIds };

    axios.post(process.env.REACT_APP_API_URL + "v1/assign-bookings", data, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setLoading(false);
        onSubmit();
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  };

  return (<form onSubmit={handleSubmit(onSubmitLocal)}>
    <div className={`${styles.FormMainRow}`}>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Driver*</InputLabel>
          <Controller
            control={control}
            {...register("driver_id", { required: "Please select driver" })}
            render={({ field }) => (
              <Select {...field} label="Select Driver*">
                {driverList?.map((i) => {
                  return (<MenuItem key={i?.id} value={i?.id}>{i?.name}</MenuItem>);
                })}
              </Select>
            )}
          />
        </FormControl>
        {errors.driver_id && (<span className={`ErrorM`}>{errors?.driver_id?.message}</span>)}
      </div>
      <div className={`FormButtonArea`}>
        <Button className={`CancelBU`} onClick={(e) => modalClose(false)}>Cancel</Button>
        <Button className={`SubmitBU`} type="submit">Assign</Button>
      </div>
    </div>
  </form>);
}